// adds special character validation for engraving products
window.addEventListener("load", function() {
  if(window.engraveService){
    const engravingInputs = document.querySelectorAll('.pplr-wrapper .pplr_text')
    const regex = new RegExp(/^[\u00C0\u00C1\u00C2\u00C3\u00C4\u00C5\u00C6\u00C7\u00C8\u00C9\u00CA\u00CB\u00CC\u00CD\u00CE\u00CF\u00D1\u00D2\u00D3\u00D4\u00D5\u00D6\u00D8\u00D9\u00DA\u00DB\u00DC\u00DD\u00DF\u00E0\u00E1\u00E2\u00E3\u00E4\u00E5\u00E6\u00E7\u00E8\u00E9\u00EA\u00EB\u00EC\u00ED\u00EE\u00EF\u00F1\u00F2\u00F3\u00F4\u00F5\u00F6\u00F8\u00F9\u00FA\u00FB\u00FC\u00FDa-zA-Z0-9 !"#$%&()*+,-.\/:;<=>?@[\]“…–´`‘’'^_{|}~€§:copyright:²³µ°\\´:eingetragen:]+$/i);
    let allowedArray = [];
    const atcBtn = document.getElementById('AddToCart')
    const characterError = document.querySelector('.ProductForm__characterError')

    engravingInputs.forEach(function(element){
      element.addEventListener('input', function(){
        allowedArray = []
        for (const [key, value] of Object.entries(document.querySelectorAll('.pplr-wrapper .pplr_text'))) {
          checkAllowedCharacters(value)
        }
      });
    })

    function checkAllowedCharacters(e){
      let matches = regex.test(e.value);
      let checked = true

      if(e.value == 0 || matches){
        checked = true
      } else if(!matches){
        checked  = false
        allowedArray.push(checked)
      }

      if(allowedArray.includes(false)){
        atcBtn.setAttribute('disabled', 'true');
        characterError.style.display = 'block';
      } else{
        atcBtn.removeAttribute('disabled');
        characterError.style.display = 'none';
      }
    }
  }
});

window.addEventListener("pplrAppInitiated", function() {
  if(window.pplr_after_cart) {
    const originalPplrAfterCart = window.pplr_after_cart;

    window.pplr_after_cart = function customPplrAjaxCart(variant, form) {
      const eventData = {
        event: 'dl_add_to_cart',
        ecommerce: {
          currencyCode: 'EUR',
          add: {
            products: [{
              id: variant.sku,
              name: variant.product_title,
              brand: variant.vendor,
              category: variant.product_type,
              variant: variant.title,
              price: (parseFloat(variant.price) / 100).toFixed(2),
              quantity: variant.quantity,
              product_id: variant.product_id,
              variant_id: variant.variant_id,
              compare_at_price: (parseFloat(variant.original_price) / 100).toFixed(2),
              image: variant.image,
              dimension1: window.customGtmProductInformation.product.productLinie,
              dimension3: window.customGtmProductInformation.product.itemCategory,
              dimension6: window.customGtmProductInformation.product.engraveService,
              dimension10: window.customGtmProductInformation.product.collections,
              dimension11: window.customGtmProductInformation.product.referrerCategory,
            }]
          }
        }
      };

      window.pushEventWithConsent(eventData);

      originalPplrAfterCart.apply(this, arguments);
    }
  }
}.bind(this));

// PDP Breadcrumbs
window.addEventListener("DOMContentLoaded", () => {
  const pdpBreadcrumbs = document.querySelectorAll(
    "[data-product-breadcrumbs]"
  );
  Array.prototype.forEach.call(pdpBreadcrumbs, (breadcrumbs) => {
    const { host, origin } = window.location;
    const regex = new RegExp(`${host}\/collections\/(.*)\/?$`);
    const matches = (document.referrer || "").match(regex);

    if (matches && matches[1]) {
      fetch(`${origin}/collections/${matches[1]}.json`)
        .then((res) => res.json())
        .then(({ collection }) => {
          if(collection) {
            const newBreadcrumb = document.createElement("div");
            newBreadcrumb.innerHTML = `
              <li class="breadcrumb__item">
                <a class="breadcrumb__link" href="${origin}/collections/${collection.handle}">${collection.title}</a>
              </li>
            `;

            let newBreadcrumbSchema = JSON.parse(
              `{
                "@type": "ListItem",
                "name": "${collection.title}",
                "item": "${origin}/collections/${collection.handle}"
              }`
            );

            const breadcrumbSchema = document.querySelector("#schema-breadcrumb");

            const categoryBreadcrumb = breadcrumbs.querySelector(".js-breadcrumb-category");
            if(categoryBreadcrumb) {
              if(breadcrumbSchema) {
                let jsonSchema = JSON.parse(breadcrumbSchema.innerHTML);
                jsonSchema.itemListElement.forEach((element, i) => {
                  if(element.name == categoryBreadcrumb.dataset.name) {
                    newBreadcrumbSchema.position = jsonSchema.itemListElement[i].position;
                    jsonSchema.itemListElement[i] = newBreadcrumbSchema;
                  }
                })
                breadcrumbSchema.innerHTML = JSON.stringify(jsonSchema);
              }

              categoryBreadcrumb.replaceWith(newBreadcrumb.firstElementChild);
            } else {
              const lastItem = breadcrumbs.querySelector(".breadcrumb__item:last-child");
              if (lastItem) {
                lastItem.parentElement.insertBefore(newBreadcrumb.firstElementChild, lastItem);

                let jsonSchema = JSON.parse(breadcrumbSchema.innerHTML);
                newBreadcrumbSchema.position = jsonSchema.itemListElement.length;
                jsonSchema.itemListElement.push(jsonSchema.itemListElement[jsonSchema.itemListElement.length - 1]);
                jsonSchema.itemListElement[jsonSchema.itemListElement.length - 2] = newBreadcrumbSchema;
                jsonSchema.itemListElement[jsonSchema.itemListElement.length - 1].position = jsonSchema.itemListElement.length;
                breadcrumbSchema.innerHTML = JSON.stringify(jsonSchema);
              }
            }
          }
        });
    }
  });
});

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const isProductPage = window.isProduct;
    const qAndAContainer = document.querySelector('[data-qanda-container]');

    if (!isProductPage || !qAndAContainer) return;


    // determine when the observer should trigger the callback
    const observerSettings = {
      attributes: false,
      childList: true,
      subtree: true,
    };

    // check if the shopify spr-app injects its form and modify it
    const observer = new MutationObserver(function (mutationList, observer) {
      for (const mutation of mutationList) {
        const maybeForm = mutation.target.querySelector('.new-review-form');
        const ratingInput = maybeForm && maybeForm.querySelector("[name='review[rating]']");
        const bodyInput = maybeForm && maybeForm.querySelector("[name='review[body]']");
        const formActions = maybeForm && maybeForm.querySelector('.spr-form-actions');
        if (
          !maybeForm ||
          !ratingInput ||
          !bodyInput ||
          !formActions
        )
          continue;

        // get HTML for additional information below the submit button
        const qandaNotice = qAndAContainer.dataset.qandaNotice;

        if (qandaNotice != undefined) {
          try {
            formActions.insertAdjacentHTML('afterEnd', JSON.parse(qandaNotice));
          } catch (e) {
            console.error('invalid html string', e);
          }
        }

        // modify submit callback and inject static values for unused but still required fields
        maybeForm.addEventListener('submit', function () {
          bodyInput.value = 'no-content';
          ratingInput.value = 5;
          SPR.submitForm(this);
          return false;
        });

        observer.disconnect();
        break;
      }
    });

    observer.observe(qAndAContainer, observerSettings);
  });
})();

// js/custom-element/section/product/review-link.js
window.addEventListener("DOMContentLoaded", () => {
  if (!window.customElements.get("review-link")) {
    var ReviewLink = class extends HTMLAnchorElement {
      constructor() {
        super();
        this.addEventListener("click", this._onClick.bind(this));
      }
      _onClick() {
        const shopifyReviewsElement = document.getElementById("shopify-product-reviews");
        if (!shopifyReviewsElement) {
          return;
        }
        if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
          shopifyReviewsElement.closest("collapsible-content").open = true;
        } else {
          document.querySelector(`[aria-controls="${shopifyReviewsElement.closest(".product-tabs__tab-item-wrapper").id}"]`).click();
        }
      }
    };
    window.customElements.define("review-link", ReviewLink, { extends: "a" });
  }
})

window.addEventListener('DOMContentLoaded', () => {
	const urlParams = new URLSearchParams(window.location.search)
	const comesFromJudgeMeLink = urlParams.has('judgeme_review_source')

	if (comesFromJudgeMeLink) {
		const observer = new MutationObserver((mutations, observer) => {
			const reviewLink = document.querySelector(
				'.jdgm-preview-badge--with-link'
			)
			if (reviewLink) {
				reviewLink.click()
				observer.disconnect()
			}
		})

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		})
	}
})